import type { $Fetch } from "nitropack";
import type { IApi } from "~/interfaces/IApi";
import { useAuthStore } from "~/store/useAuthStore";

export class BaseApi implements IApi {
  // @ts-ignore
  $fetch: $Fetch;

  constructor() {
    this.create();
  }

  private create() {
    const config = useRuntimeConfig();
    const authStore = useAuthStore();

    this.$fetch = $fetch.create({
      baseURL: config.public.apiBase,
      onRequest: async ({ options }) => {
        options.credentials = "include";
        if (!(options.body instanceof FormData)) {
          options.headers.set("Content-Type", "application/json");
        }
      },
      onResponseError: async ({ response }) => {
        if (response.status === 401) {
          authStore.setAuthCookie(null);
          await navigateTo(routes.authLogin());
        }
      },
    });
  }
}
